import React from "react"
import HomeTemplate from "templates/HomeTemplate/HomeTemplate"

const IndexPage = () => <HomeTemplate lang="ES" />

export default IndexPage
